module.exports = require("./build/ReactDocumentEvents.js");
